import React, { useState, useEffect } from "react";
import "./PermissionForm.css";

const PermissionForm = ({ role, onClose, onSave }) => {
  const [allPermissions, setAllPermissions] = useState([]);
  const [assignedPermissions, setAssignedPermissions] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Fetch available permissions + current role’s assigned ones
  useEffect(() => {
    async function fetchData() {
      try {
        const [permRes, rolePermRes] = await Promise.all([
          fetch("/api/permissions"),
          fetch(`/api/roles/${role.role_id}/permissions`)
        ]);

        const perms = await permRes.json();
        const rolePerms = await rolePermRes.json();

        setAllPermissions(perms);
        setAssignedPermissions(new Set(rolePerms.map(p => p.permission_key)));
      } catch (err) {
        console.error("Error fetching permissions:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [role.role_id]);

  const togglePermission = (key) => {
    setAssignedPermissions((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(key)) newSet.delete(key);
      else newSet.add(key);
      return newSet;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const response = await fetch(`/api/roles/${role.role_id}/permissions`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: Array.from(assignedPermissions) }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to save permissions");
      }

      alert("✅ Permissions updated successfully!");

      // ✅ If the edited role is the same as the currently logged-in user’s role:
      const currentRoleId = localStorage.getItem("role_id");
      if (String(currentRoleId) === String(role.role_id) && data.updatedPermissions) {
        localStorage.setItem("permissions", JSON.stringify(data.updatedPermissions));
        console.log("🔄 Permissions refreshed:", data.updatedPermissions);
      }

      // ✅ Trigger parent UI refresh
      onSave();

    } catch (error) {
      console.error("❌ Save error:", error);
      alert(error.message || "Failed to save permissions");
    } finally {
      setSaving(false);
    }
  };


  if (loading) return <div className="modal-overlay"><div className="modal-content"><p>Loading permissions...</p></div></div>;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>✖</button>
        <h3>Edit Permissions for {role.role_name}</h3>

        <form onSubmit={handleSubmit}>
          <table className="permission-table">
            <thead>
              <tr>
                <th>Permission</th>
                <th>Allowed</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(allPermissions) && allPermissions.length > 0 ? (
                allPermissions.map((perm) => (
                  <tr key={perm.permission_id}>
                    <td>{perm.description}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={assignedPermissions.has(perm.permission_key)}
                        onChange={() => togglePermission(perm.permission_key)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" style={{ textAlign: "center", color: "gray" }}>
                    No permissions found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="form-actions">
            <button type="submit" disabled={saving}>
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PermissionForm;
